// extracted by mini-css-extract-plugin
export default {"uploadButton":"DropZone_uploadButton__RM190","dropzone":"DropZone_dropzone__n1ydJ"};